import moment from 'moment';
import { useCallback } from 'react';
import { useApiError, useAppData, useLoading } from 'src/providers';
import { ReportMessageContent } from 'src/models';
import { useSnackbar } from 'notistack';
import { DateRange } from '@material-ui/pickers';
import { sendEmail } from '../CommissionsByClientService';
import { enColumnsForEmail } from '../CommissionsByClientModel';
import { trackAmplitudeData } from '../../../../services/amplitudeService';

const useSendEmail = ({ dateRange, translation }: { dateRange: DateRange<Date>; translation: any }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { setIsLoading } = useLoading();
  const { userData, translations } = useAppData();
  const { addError } = useApiError();

  return useCallback(async () => {
    const loginData = JSON.parse(userData);

    if (dateRange && dateRange[0] && dateRange[1]) {
      const messageContent: ReportMessageContent = {
        PartnerId: loginData.PartnerID,
        Month: dateRange[0].getMonth() + 1,
        Year: dateRange[0].getFullYear(),
        Day: dateRange[0].getDate(),
        EndMonth: dateRange[1].getMonth() + 1,
        EndYear: dateRange[1].getFullYear(),
        EndDay: dateRange[1].getDate(),
        ConvertToCurrency: 'USD',
        RequestorAccountGuid: loginData.defaultAccount,
      };

      setIsLoading(true);
      try {
        trackAmplitudeData('partnerPortal_action_report', {
          type: 'SendByEmail',
          report_name: 'Commissions By Client',
        });

        // const tableColumns = getSelectedColumnsInEn(en, selected, reportColumns);
        await sendEmail({
          ...messageContent,
          reportEmailRequest: {
            email: '',
            startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
            endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
            includeTotal: true,
            translatedTableColumns: [translation.text_6625, translation.text_6626, translation.text_6627, translation.text_6628, translation.text_6629, translation.total_lots || 'Total Lots', translation.text_6630, translation.text_6631, translation.text_6632, translation.text_6633],
            tableColumns: enColumnsForEmail,
          },
        });

        enqueueSnackbar(`${JSON.parse(translations).text_1640} ${loginData.userEmail}.`, {
          variant: 'success',
        });
      } catch (error) {
        addError(JSON.stringify(error.response));
      } finally {
        setIsLoading(false);
      }
    }
  }, [userData, dateRange, setIsLoading, enqueueSnackbar, translations, addError, translation]);
};

export default useSendEmail;
